import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { class: "orders" };
const _hoisted_2 = {
    key: 0,
    class: "data-table__value-topic"
};
const _hoisted_3 = { class: "data-table__value-text" };
const _hoisted_4 = {
    key: 0,
    class: "data-table__value-topic"
};
const _hoisted_5 = { class: "data-table__value-text" };
const _hoisted_6 = {
    key: 0,
    class: "data-table__value",
    style: { height: '100%' }
};
const _hoisted_7 = ["src", "alt"];
const _hoisted_8 = {
    class: "modal__title",
    style: { "padding": "0", "margin": "0" }
};
import { onMounted, onUnmounted, ref } from 'vue';
import { useRoute, useRouter } from "vue-router";
import DataTable from "@astina/paloma-common-ui/src/components/DataTable.vue";
import orderRepository from '../services/OrderRepository';
import events from "@astina/paloma-common-ui/src/services/EventBus";
import Spinner from "@astina/paloma-common-ui/src/components/Spinner.vue";
import CommandButton from "@astina/paloma-common-ui/src/components/CommandButton.vue";
import CreateOrderDraft from "../commands/CreateOrderDraft";
import DeleteOrderDraft from "../commands/DeleteOrderDraft";
import RepeatOrder from "../commands/RepeatOrder";
import BadgeComponent from "@astina/paloma-common-ui/src/components/BadgeComponent.vue";
import Modal from "@astina/paloma-common-ui/src/components/Modal.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'OrdersView',
    setup(__props) {
        const route = useRoute();
        const router = useRouter();
        const searchRequest = ref({
            query: null,
            filters: []
        });
        const enforceSearchRequest = ref(false);
        const grid = ref(null);
        const source = ref(orderRepository.getGridItemsSource());
        const createOrderDraft = ref(new CreateOrderDraft());
        const showPurchaseSuccessModal = ref(false);
        onMounted(() => {
            // @ts-ignore
            const status = route.query.status;
            if (status) {
                searchRequest.value.filters = [{
                        attribute: "status",
                        values: [status],
                    }];
                enforceSearchRequest.value = true;
            }
            orderRepository.getGridConfig().then(g => {
                grid.value = g;
            });
        });
        events.$on('command.create_order_draft.success', onCreateOrderDraftSuccess);
        events.$on('command.repeat_order.success', onCreateOrderDraftSuccess);
        events.$on('command.delete_order_draft.success', onDeleteOrderDraftSuccess);
        events.$on('command.purchase_order.success', onPurchaseOrderSuccess);
        onUnmounted(() => {
            events.$off('command.create_order_draft.success', onCreateOrderDraftSuccess);
            events.$off('command.repeat_order.success', onCreateOrderDraftSuccess);
            events.$off('command.delete_order_draft.success', onDeleteOrderDraftSuccess);
            events.$off('command.purchase_order.success', onPurchaseOrderSuccess);
        });
        function activateItem(item) {
            if (!item) {
                closeDetailView();
            }
            else if (item.status === 'draft') {
                router.push({ name: 'orders_draft', params: { id: item.id } }).catch(() => {
                });
            }
            else {
                router.push({
                    name: 'orders_order',
                    params: { orderNumber: item.attributes['orderNumber'] }
                }).catch(() => {
                });
            }
        }
        function orderStatusBadge(item) {
            const status = item.attributes['status'];
            switch (status) {
                case 'draft':
                    return 'text-bg-secondary';
                case 'delivered':
                    return 'text-bg-success';
                case 'canceled':
                case 'returned':
                case 'refunded':
                    return 'text-bg-dark';
                default:
                    return 'text-bg-info';
            }
        }
        function repeatOrderCommand(item) {
            return new RepeatOrder(item.attributes['orderNumber']);
        }
        function cartDeleteCommand(item) {
            return new DeleteOrderDraft(item.id);
        }
        function closeDetailView() {
            router.push({ name: 'orders' });
        }
        function selectNextItem() {
            events.$emit('orders.nav-next');
        }
        function selectPrevItem() {
            events.$emit('orders.nav-prev');
        }
        function onCreateOrderDraftSuccess(cart) {
            // TODO activate item
            router.push({ name: 'orders_draft', params: { id: cart.id } }).catch(() => {
            });
            events.$emit('orders.refresh');
        }
        function onDeleteOrderDraftSuccess() {
            refreshAndGotoOverview();
        }
        function onPurchaseOrderSuccess() {
            showPurchaseSuccessModal.value = true;
            refreshAndGotoOverview();
        }
        function refreshAndGotoOverview() {
            router.push({ name: 'orders' }).catch(() => {
            });
            events.$emit('orders.refresh');
        }
        return (_ctx, _cache) => {
            const _component_router_link = _resolveComponent("router-link");
            const _component_router_view = _resolveComponent("router-view");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(Spinner, {
                    loading: !grid.value
                }, null, 8, ["loading"]),
                _cache[17] || (_cache[17] = _createTextVNode()),
                (grid.value)
                    ? (_openBlock(), _createBlock(DataTable, {
                        key: 0,
                        name: "orders",
                        title: _ctx.$t('orders'),
                        "search-request": searchRequest.value,
                        "enforce-search-request": enforceSearchRequest.value,
                        grid: grid.value,
                        source: source.value,
                        onActivateItem: activateItem
                    }, {
                        actions: _withCtx(() => [
                            (createOrderDraft.value)
                                ? (_openBlock(), _createBlock(CommandButton, {
                                    key: 0,
                                    command: createOrderDraft.value,
                                    classes: ['button', 'button--primary'],
                                    icon: "shopping-cart",
                                    label: _ctx.$t('orders.create_draft')
                                }, null, 8, ["command", "label"]))
                                : _createCommentVNode("", true)
                        ]),
                        "list-item": _withCtx((props) => [
                            (props.item.status === 'draft')
                                ? (_openBlock(), _createBlock(_component_router_link, {
                                    key: 0,
                                    to: { name: 'orders_draft', params: { id: props.item.id } },
                                    class: "data-table__value"
                                }, {
                                    default: _withCtx(() => [
                                        (props.item.topic)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.$dateTime(props.item.topic)), 1))
                                            : _createCommentVNode("", true),
                                        _cache[5] || (_cache[5] = _createTextVNode()),
                                        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('orders.draft')), 1),
                                        _cache[6] || (_cache[6] = _createTextVNode()),
                                        (props.item.attributes['_buyer'])
                                            ? (_openBlock(), _createBlock(BadgeComponent, { key: 1 }, {
                                                default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(props.item.attributes['_buyer']), 1)
                                                ]),
                                                _: 2
                                            }, 1024))
                                            : _createCommentVNode("", true)
                                    ]),
                                    _: 2
                                }, 1032, ["to"]))
                                : _createCommentVNode("", true),
                            _cache[9] || (_cache[9] = _createTextVNode()),
                            (props.item.status !== 'draft')
                                ? (_openBlock(), _createBlock(_component_router_link, {
                                    key: 1,
                                    to: { name: 'orders_order', params: { orderNumber: props.item.attributes['orderNumber'] } },
                                    class: "data-table__value"
                                }, {
                                    default: _withCtx(() => [
                                        (props.item.topic)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.$dateTime(props.item.topic)), 1))
                                            : _createCommentVNode("", true),
                                        _cache[7] || (_cache[7] = _createTextVNode()),
                                        _createElementVNode("span", _hoisted_5, _toDisplayString(props.item.title), 1),
                                        _cache[8] || (_cache[8] = _createTextVNode()),
                                        (props.item.attributes['_buyer'])
                                            ? (_openBlock(), _createBlock(BadgeComponent, { key: 1 }, {
                                                default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(props.item.attributes['_buyer']), 1)
                                                ]),
                                                _: 2
                                            }, 1024))
                                            : _createCommentVNode("", true)
                                    ]),
                                    _: 2
                                }, 1032, ["to"]))
                                : _createCommentVNode("", true)
                        ]),
                        "item-actions": _withCtx((props) => [
                            (props.item.status !== 'draft')
                                ? (_openBlock(), _createBlock(CommandButton, {
                                    key: 0,
                                    command: repeatOrderCommand(props.item),
                                    label: "",
                                    title: _ctx.$t('command.repeat_order'),
                                    classes: ['button', 'button--link']
                                }, null, 8, ["command", "title"]))
                                : _createCommentVNode("", true),
                            _cache[10] || (_cache[10] = _createTextVNode()),
                            (props.item.status === 'draft')
                                ? (_openBlock(), _createBlock(CommandButton, {
                                    key: 1,
                                    command: cartDeleteCommand(props.item),
                                    label: "",
                                    classes: ['button', 'button--link']
                                }, null, 8, ["command"]))
                                : _createCommentVNode("", true)
                        ]),
                        "cell-_items": _withCtx((props) => [
                            (props.item.attributes['_items'])
                                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.item.attributes['_items'].items, (item, index) => {
                                        return (_openBlock(), _createElementBlock("img", {
                                            src: item.imageUrl,
                                            key: index,
                                            alt: item.name,
                                            style: { 'margin-right': '.2rem' }
                                        }, null, 8, _hoisted_7));
                                    }), 128))
                                ]))
                                : _createCommentVNode("", true)
                        ]),
                        "cell-status": _withCtx((props) => [
                            _createElementVNode("span", {
                                class: _normalizeClass(["badge", orderStatusBadge(props.item)])
                            }, _toDisplayString(_ctx.$t('order.status.' + props.item.attributes['status'])), 3)
                        ]),
                        _: 1
                    }, 8, ["title", "search-request", "enforce-search-request", "grid", "source"]))
                    : _createCommentVNode("", true),
                _cache[18] || (_cache[18] = _createTextVNode()),
                (showPurchaseSuccessModal.value)
                    ? (_openBlock(), _createBlock(Modal, {
                        key: 1,
                        onClose: _cache[1] || (_cache[1] = ($event) => (showPurchaseSuccessModal.value = false)),
                        classes: ['modal--medium']
                    }, {
                        header: _withCtx(() => [
                            _createElementVNode("h2", _hoisted_8, _toDisplayString(_ctx.$t('orders.purchase_success')), 1)
                        ]),
                        content: _withCtx(() => [
                            _createElementVNode("p", null, _toDisplayString(_ctx.$t('orders.purchase_success_info')), 1),
                            _cache[15] || (_cache[15] = _createTextVNode()),
                            _createElementVNode("a", {
                                onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (showPurchaseSuccessModal.value = false), ["prevent"])),
                                class: "button"
                            }, _toDisplayString(_ctx.$t('close')), 1)
                        ]),
                        _: 1
                    }))
                    : _createCommentVNode("", true),
                _cache[19] || (_cache[19] = _createTextVNode()),
                _createVNode(_component_router_view, {
                    onClose: _cache[2] || (_cache[2] = ($event) => (closeDetailView())),
                    onNext: _cache[3] || (_cache[3] = ($event) => (selectNextItem())),
                    onPrev: _cache[4] || (_cache[4] = ($event) => (selectPrevItem()))
                })
            ]));
        };
    }
});
